import { useNavigate } from "react-router-dom"
import styled from "styled-components"
import { colors } from "../../Utils/color"

const MoviesContainerDiv = styled.div`
    display: flex;
    gap: 10px;
    max-width: 100%;
    overflow-x: auto;
    scrollbar-width: none;
    margin: 0 10px;
    padding-bottom: 10px;
    @media screen and (min-width: 1024px) {
        margin: 0 130px;
        padding-bottom: 20px;
    }
`

export const MovieElementDiv = styled.div`
    max-width: 23vh;
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 5px;
    cursor: pointer;

    @media screen and (min-width: 480px) {
        max-width: 24vh;
    }

    @media screen and (min-width: 768px) {
        max-width: 25vh;
    }

    @media screen and (min-width: 1024px) {
        max-width: 26.5vh;
    }

    img {
        width: 23vh;
        height: 30vh;
        object-fit: cover;
        opacity: 0.85;
        border-radius: 15px;
        background-color: ${colors.secondary};

        &:hover {
            opacity: 1;
        }

        @media screen and (min-width: 480px) {
            height: 32vh;
            width: 24vh;
        }

        @media screen and (min-width: 768px) {
            height: 34vh;
            width: 25vh;
        }

        @media screen and (min-width: 1024px) {
            height: 38vh;
            width: 26.5vh;
        }
    }

    > p {
        font-size: 1.05em;
        font-weight: 500;
        margin: 0;
    }
`

export function slugify(text) {
    return text
        .normalize("NFD") // décompose les accents (é -> e + ́)
        .replace(/[\u0300-\u036f]/g, "") // supprime les diacritiques
        .replace(/[^a-zA-Z0-9]+/g, "-") // remplace espaces et caractères spéciaux par un tiret
        .replace(/^-+|-+$/g, "") // supprime les tirets en début et fin
        .toLowerCase() // met tout en minuscule
}

function MoviesSlider({ movies, moviesRef, type }) {
    /*
    const handleScroll = (e) => {
        const right =
            Math.abs(
                e.target.scrollWidth -
                    (e.target.scrollLeft + e.target.clientWidth),
            ) <= 1
    }
    */

    const navigate = useNavigate()
    const movieHandleClick = (id, titre) => {
        const urlTitle = slugify(titre)

        if (type === "film") {
            navigate(`/film/${urlTitle}?film_id=${id}`)
        } else if (type === "serie") {
            navigate(`/serie/${urlTitle}?serie_id=${id}`)
        }
    }

    return (
        <MoviesContainerDiv ref={moviesRef}>
            {movies.map(({ id, titre, cover }) => (
                <MovieElementDiv
                    key={id}
                    onClick={() => movieHandleClick(id, titre)}
                >
                    <img src={cover} alt="Movies cover" />
                    <p>{titre}</p>
                </MovieElementDiv>
            ))}
        </MoviesContainerDiv>
    )
}

export default MoviesSlider
